import { Activity, Box, HeartPulse } from "lucide-react";
import { SectionNumber } from "../visuals/SectionNumber";

const steps = [
    {
        n: "01",
        icon: Activity,
        title: "Identify",
        desc: "A bystander recognizes overdose signs. Kairos units are clearly marked, well-lit, and intuitive — designed for any first-time responder.",
    },
    {
        n: "02",
        icon: Box,
        title: "Access",
        desc: "One-touch emergency release dispenses OTC Naloxone. No app, no account — and the moment the unit is activated, staff and EMS are auto-notified so bystanders can stay focused on the person needing help.",
    },
    {
        n: "03",
        icon: HeartPulse,
        title: "Administer",
        desc: "Visual + audio guidance walks the responder through nasal administration per the FDA-approved OTC Naloxone label. EMS is auto-notified with location and event timestamp.",
    },
];

export const HowItWorks = () => {
    return (
        <section
            id="how"
            data-testid="how-it-works-section"
            className="relative bg-slate-50 py-28 md:py-36 border-y border-slate-200"
        >
            <SectionNumber n={3} total={12} />
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="reveal max-w-3xl">
                    <span className="text-xs md:text-sm font-bold uppercase tracking-[0.28em] text-[#F0493E]">
                        How It Works
                    </span>
                    <h2 className="mt-6 font-display font-extrabold text-4xl md:text-6xl leading-[0.98] tracking-tighter text-[#0A1428] text-balance">
                        Three steps between
                        <br />
                        crisis and recovery.
                    </h2>
                </div>

                <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
                    {steps.map((s, i) => (
                        <div
                            key={s.n}
                            data-testid={`how-step-${s.n}`}
                            className="reveal relative bg-white border border-slate-200 p-8 md:p-10 hover:border-[#0A1428] transition-colors"
                            style={{ transitionDelay: `${i * 80}ms` }}
                        >
                            <div className="font-display font-extrabold text-7xl md:text-8xl text-slate-100 leading-none tnum">
                                {s.n}
                            </div>
                            <div className="mt-4 h-12 w-12 grid place-items-center border border-[#0A1428]">
                                <s.icon
                                    size={22}
                                    strokeWidth={1.5}
                                    className="text-[#F0493E]"
                                />
                            </div>
                            <h3 className="mt-6 font-display font-bold text-2xl text-[#0A1428]">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-base text-slate-600 leading-relaxed font-medium">
                                {s.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
